import { MotifButton, MotifToast } from '@ey-xd/motif-react';
import React, { useState, useEffect } from 'react';
import '../alerts/alertStyle.css';
import styled from 'styled-components';
import Button from '../button';
import { device } from '../../../util/commonMediaStylesUtil';

const AlertBanner = ({ title, description, type, showButton }) => {
  const [visible1, setVisible1] = useState(true);
  const [visible2, setVisible2] = useState(true);
  const [visible3, setVisible3] = useState(true);
  const [visible4, setVisible4] = useState(true);

  const AlertContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    ${device.phone_l`
      margin-left: 10px;
      flex-direction: column;
      align-items: start;
    `}
  `;

  const AlertTextContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    ${device.phone_l`
      flex-direction: column;
      align-items: start;
    `}
  `;

  const AlertTitle = styled.span`
    font-family: EYInterstate;
    font-size: 14px;
    font-weight: 600;
    line-height: 2;
    margin-right: 12px;
  `;

  const AlertDescription = styled.span`
    font-size: 14px;
    font-weight: 300;
    font-family: EYInterstate;
    color: #2e2e38;
  `;

  const ButtonContainer = styled.span`
    float: right;
    padding-left: 5px;
    ${device.phone_l`
      padding-top: 5px;
      padding-left: 0px;
    `}
  `;

  return (
    <>
      {visible1 && type == 'error' && (
        <MotifToast variant="error" className="error-toast" onClose={() => setVisible1(false)}>
          <AlertContainer>
            <AlertTextContainer>
              <AlertTitle style={{ color: '#B9251C' }}> {title}</AlertTitle>
              <AlertDescription>{description}</AlertDescription>{' '}
            </AlertTextContainer>
            {showButton && (
              <ButtonContainer>
                <Button title={'Start Forecast'} targetURL="/forecast" size="large" />
              </ButtonContainer>
            )}
          </AlertContainer>
        </MotifToast>
      )}

      {visible2 && type == 'success' && (
        <MotifToast variant="success" className="sucess-toast" onClose={() => setVisible2(false)}>
          <AlertContainer>
            <AlertTextContainer>
              <AlertTitle style={{ color: '#168736' }}> {title}</AlertTitle>
              <AlertDescription>{description}</AlertDescription>{' '}
            </AlertTextContainer>
            {showButton && (
              <ButtonContainer>
                <Button title={'Start Forecast'} targetURL="/forecast" size="large" />
              </ButtonContainer>
            )}
          </AlertContainer>
        </MotifToast>
      )}

      {visible3 && type == 'warning' && (
        <MotifToast variant="warning" className="warning-toast" onClose={() => setVisible3(false)}>
          <AlertContainer>
            <AlertTextContainer>
              <AlertTitle style={{ color: '#BC2F00' }}> {title}</AlertTitle>
              <AlertDescription> {description} </AlertDescription>
            </AlertTextContainer>
            {showButton && (
              <ButtonContainer>
                <Button title={'Start Forecast'} targetURL="/forecast" size="large" />
              </ButtonContainer>
            )}
          </AlertContainer>
        </MotifToast>
      )}

      {visible4 && type == 'info' && (
        <MotifToast
          variant="info"
          className="Alert-Prompt-Icon-Color info-toast"
          onClose={() => setVisible4(false)}
        >
          <AlertContainer>
            <AlertTextContainer>
              <AlertTitle style={{ color: '#585860' }}> {title}</AlertTitle>
              <AlertDescription>{description}</AlertDescription>{' '}
            </AlertTextContainer>
            {showButton && (
              <ButtonContainer>
                <Button title={'Start Forecast'} targetURL="/forecast" size="large" />
              </ButtonContainer>
            )}
          </AlertContainer>
        </MotifToast>
      )}

      {visible4 && type == 'past' && (
        <MotifToast
          variant="info"
          className="Alert-Prompt-Icon-Color past-toast"
          onClose={() => setVisible4(false)}
        >
          <AlertContainer>
            <AlertTextContainer>
              <AlertTitle style={{ color: '#585860', fontWeight: 600 }}> {title}</AlertTitle>
              <AlertDescription>{description}</AlertDescription>{' '}
            </AlertTextContainer>
          </AlertContainer>
        </MotifToast>
      )}
    </>
  );
};
export default AlertBanner;
